import {loadHomeAsync} from '../../services/api/home';

export const LOAD_HOME_START = 'LOAD_HOME_START';
export const LOAD_HOME_ERROR = 'LOAD_HOME_ERROR';
export const LOAD_HOME_COMPLETE = 'LOAD_HOME_COMPLETE';

export const loadHome = () => async (dispatch, getState) => {
    dispatch({type: LOAD_HOME_START});

    let watchedVideos = Object.values(getState().recommendation.videos)
        .filter(video => video.showId)
        .slice(0, 5)
        .reduce((acc, curr) => [...acc, curr.id], []);

    try {
        let rows = await loadHomeAsync(watchedVideos.join(','));
        dispatch({type: LOAD_HOME_COMPLETE, rows});
    } catch (error) {
        dispatch({type: LOAD_HOME_ERROR, error});
    }
};
